import { render, staticRenderFns } from "./productBatch.vue?vue&type=template&id=13205a6f&scoped=true&"
import script from "./productBatch.vue?vue&type=script&lang=ts&"
export * from "./productBatch.vue?vue&type=script&lang=ts&"
import style0 from "./productBatch.vue?vue&type=style&index=0&id=13205a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13205a6f",
  null
  
)

export default component.exports